import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

import { cn } from '../../lib/utils'

const stackVariants = cva('flex flex-col', {
  variants: {
    size: {
      sm: 'gap-3',
      md: 'gap-6',
      lg: 'gap-10',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

type StackProps = React.ComponentProps<'div'> & VariantProps<typeof stackVariants>

function Stack({ className, size, ...props }: StackProps) {
  return <div data-slot="stack" className={cn(stackVariants({ size }), className)} {...props} />
}

export { Stack, stackVariants, type StackProps }
